import Example from "../../../../content/20220601/Example";
import * as React from 'react';
export default {
  Example,
  React
};